export default {
	REPORTS: 'companies/:company_id/reports/',
	SAVE_REPORT: 'companies/:company_id/reports/save-report',
	AUTO_REPORTS: 'companies/:company_id/reports/auto-reports',
	RENT_ROLL: 'companies/:company_id/reports/rent-roll',
	REPORTS_BILLED_PRODUCTS: 'companies/:company_id/reports/billed-products',
	REPORT_PAYMENTS: 'companies/:company_id/reports/payments',
	REPORT_VACANCIES: 'companies/:company_id/reports/vacancies'
}
